<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><close-svg /></a>
      </div>
      <a
        :href="'/surg-info/' + surgery.surgery_order_id"
        @click.prevent="onInfo"
      >
        מעבר לפרטי הניתוח
      </a>
      <section
        v-if="
          filteredActiveDates && Object.keys(filteredActiveDates).length !== 0
        "
      >
        <div class="add_block">
          <div class="subtitle center">
            שיבוץ ניתוח עבור {{ surgery.patient_name }}
          </div>
          <form @submit.prevent="setSurgeyTime" autocomplete="off">
            <div class="w-850">
              <div class="book_hours_wrap inner_group bg--white">
                <div
                  class="add_new_row flex"
                  v-for="(date, index) in filteredActiveDates"
                  :key="index"
                >
                  <div class="add_new_row_col1">
                    {{ index
                    }}<span class="block">{{
                      $moment(index, "DD/MM/YYYY").format("יום ddd")
                    }}</span>
                  </div>
                  <div class="book_hours_slide flex flex--start">
                    <swiper
                      ref="hoursSlider"
                      :options="swiperOptions"
                      dir="rtl"
                      :auto-update="true"
                      :auto-destroy="true"
                      :delete-instance-on-destroy="true"
                      :cleanup-styles-on-destroy="true"
                    >
                      <swiper-slide
                        v-for="time in date"
                        :key="time.id + '-' + time.time"
                      >
                        <a
                          class="book_hure ease"
                          href="javascript:void(0)"
                          :class="{
                            active:
                              selectedDate == index &&
                              time.time == selectedTime.time
                          }"
                          @click.prevent="selectTime($event, time, index)"
                          >{{ time.time }}</a
                        >
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
                <div
                  class=""
                  v-if="!showAllDates && Object.keys(activeDates).length > 5"
                >
                  <a
                    href="#"
                    class="show_more_bt"
                    @click.prevent="show_num_items += 5"
                    >הצג שעות נוספות</a
                  >
                </div>
              </div>
              <div class="add_block_form flex flex--top" v-if="false">
                <div class="form_input">
                  <select2 v-model="date" dir="rtl" name="date">
                    <option value="">בחר תאריך</option>
                    <option
                      v-for="date in data"
                      :key="date.block_date"
                      :value="date.block_date"
                      >{{ date.block_date }}</option
                    >
                  </select2>
                </div>

                <div class="form_input">
                  <label>שעת התחלה*</label
                  ><input name="start_time" type="tel" /><span
                    class="error-message"
                  ></span>
                </div>
              </div>
              <div class="error-message" v-if="msg" v-html="msg"></div>
              <div class="form_submit center " :class="{ bt_disable: false }">
                <input type="submit" value="אישור שיבוץ" />
              </div>
            </div>
            <div v-if="response">{{ response }}</div>
          </form>
        </div>
      </section>
      <section v-else>
        לא ניתן לשבץ ניתוחים בתאריך זה
      </section>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
import { mapMutations } from "vuex";

export default {
  name: "scheduleSurgery",
  data() {
    return {
      date: "",
      response: "",
      activeDates: {},
      show_num_items: 5,
      showAllDates: false,
      data: [],
      selectedDate: "",
      selectedTime: "",
      surgery: [],
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: false
      },
      msg: null,
      onCLoseFunc: null
    };
  },
  watch: {
    show_num_items(value) {
      if (value >= this.data.length) {
        this.showAllDates = true;
      }
    }
  },
  mounted() {
    this.data = this.$attrs.data;
    this.surgery = this.$attrs.surgery;
    this.onCLoseFunc = this.$attrs.onCLoseFunc;
    this.$nextTick(() => {
      let times_arr = {};

      if (this.data) {
        this.data.map(block => {
          let availableTimes = block.available_time_slots_array;
          for (const index in availableTimes) {
            const slot = this.$moment(
              availableTimes[index][0],
              "YYYY-MM-DD HH:mm:ss"
            );
            const parsedDate = slot.format("DD/MM/YYYY");
            const parseTime = slot.format("HH:mm");
            if (!times_arr.hasOwnProperty(parsedDate)) {
              times_arr[parsedDate] = [];
              this.$set(times_arr, parsedDate, []);
            }
            let object = {
              id: availableTimes[index][4],
              time: parseTime
            };
            // if (
            //   typeof times_arr[parsedDate].find(t => t.id === object.id) ==
            //   "undefined"
            // ) {
            times_arr[parsedDate].push(object);
            // }
            //this.$set(times_arr, parsedDate, object);
          }
        });
      }
      this.activeDates = times_arr;
    });
  },
  methods: {
    ...mapMutations(["SET_IS_SURG_SCHEDULE"]),
    setSurgeyTime(e) {
      this.msg = null;
      if (!this.selectedTime || !this.selectedDate) {
        this.msg = "שדה חובה";
        return;
      }
      let start_time = this.$moment(
        this.selectedDate + "T" + this.selectedTime.time + ":00",
        "DD/MM/YYYYTLT"
      );
      let surgery_duration = this.surgery.surgery_duration.split(":");
      let end_time = start_time
        .clone()
        .add(surgery_duration[0], "h")
        .add(surgery_duration[1], "m");
      this.$API
        .setSurgeryDateTime(
          this.surgery.surgery_order_id,
          this.selectedTime.id,
          start_time.format("YYYY-MM-DDTLT:00"),
          end_time.format("YYYY-MM-DDTLT:00")
        )
        .then(res => {
          if (res.status == "OK") {
            this.response = res.message;
            setTimeout(() => {
              this.SET_IS_SURG_SCHEDULE(true);
              this.$emit("close");

              /// Refers to removeSurgFromNonScheduled function
              /// from DatsSlider.vue
              if (!this.onCLoseFunc) return;
              this.onCLoseFunc(this.surgery.surgery_order_id);
            }, 1000);
          }
        })
        .catch(err => {
          const condition = err.message.includes("אינה מאושרת לרופא זה");
          this.msg = condition
            ? "לא ניתן לשבץ את הניתוח </br> אין הרשאה לביצוע הניתוח"
            : "לא ניתן לשבץ את הניתוח </br> ביטוח אחריות מקצועית פג תוקף";
        });
    },
    selectTime($event, time, date) {
      this.selectedTime = time;
      this.selectedDate = date;
    },
    onInfo() {
      this.$emit("close");
      this.$router.push("/surg-info/" + this.surgery.surgery_order_id);
    }
  },
  computed: {
    filteredActiveDates() {
      let newArr = {};

      if (this.showAllDates) {
        return this.activeDates;
      } else {
        if (this.activeDates) {
          Object.assign(newArr, this.activeDates);
        }
        var sliced = Object.keys(newArr)
          .slice(0, this.show_num_items)
          .reduce((result, key) => {
            result[key] = newArr[key];

            return result;
          }, {});
        return sliced;
      }
    }
  },
  components: { CloseSvg }
};
</script>

<style scoped>
.popup_close svg path {
  fill: black;
}
.swiper-container {
  width: 100%;
}
</style>
